import { MEMBERSHIP_PRODUCT_TYPE } from './type';

/**
 * `/@api/membership/order` 호출 시 사용하는 정렬 타입
 */
export const SORT_TYPE = {
  desc: 'desc',
  asc: 'asc',
} as const;

export type MembershipCreatorItemOrder = {
  id: number;
  order_at: string;
  sid: string;
  membership_id: string;
  uid: string;
  currency_type: 'kr' | 'en' | 'jp';

  product: {
    id: number;
    price: number;
    link: string;
    name: string;
    image: string;
    image_ratio: number;
    type: keyof typeof MEMBERSHIP_PRODUCT_TYPE;
    isTpl?: boolean;
  };
};

export type MembershipUserItemOrder = {
  id: number;
  order_at: string;
  membership_id: string;
  uid: string;
  currency_type: 'kr' | 'en' | 'jp';

  product: {
    id: number;
    price: number;
    link: string;
    name: string;
    image: string;
    image_ratio: number;
    type: keyof typeof MEMBERSHIP_PRODUCT_TYPE;
    isTpl?: boolean;
  };
};
